import { Injectable } from "@angular/core";
import firebase from 'firebase';

@Injectable({ providedIn: "root" })
export class ImageService {
	uploadImage(file: File): Promise<string> {
		const ref = firebase.storage().ref(`images/${Date.now()}_${file.name}`);
		return ref.put(file).then(() => ref.getDownloadURL());
	}
}
